
import React, { useState, useEffect } from 'react';
import AnimateOnScroll from './ui/AnimateOnScroll';

const testimonials = [
  {
    id: 1,
    name: 'נטשה ל.',
    position: 'אפי-תרפיסטית',
    quote: 'אני ממליצה בחום על שירות היעוץ והליווי של שלומית, בהקמת עמוד אינטרנט לאיסוף לידים. שלומית עזרה לי לבחור את הכלים המתאימים ביותר, בעבודה פשוטה וממוקדת',
  },
  {
    id: 2,
    name: 'אריאל ',
    position: 'ייעוץ פיננסי',
    quote: 'שלומית מצאה פתרון פשוט לבעיה שהתמודדנו איתה, הדריכה בסבלנות לשימוש בכלי, ותמכה בשימש בו בהמשך',
  },
  ];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonials" className="py-10 bg-tech-gray">
      <div className="section-container">
        <AnimateOnScroll animation="animate-fade-in">
          <h2 className="section-title text-tech-darkGray">לקוחות מספרים</h2>
        </AnimateOnScroll>

        <div className="relative mt-12 h-[240px] md:h-[180px]">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`absolute top-0 right-0 w-full transition-opacity duration-500 ease-in-out ${
                index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              <div className="bg-white rounded-xl p-8 shadow-sm">
                <div>
                  <p className="text-gray-600 mb-4 text-lg font-light">"{testimonial.quote}"</p>
                  <div>
                    <h4 className="font-bold text-tech-darkGray">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.position}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-8 gap-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex ? 'bg-tech-blue scale-125' : 'bg-gray-300'
              }`}
              aria-label={`עבור לעדות ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
